import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { ServicingCommonStoreService } from '@common/services';
import { MyBookingItineraryService } from '@common/services/my-booking/my-booking-itinerary.service';
import { TripSummaryService } from '@common/services/my-booking/trip-summary.service';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { Subscription } from 'rxjs';
import { Bound, GetOrderResponseData, Type1 } from 'src/sdk-servicing';

@Component({
  selector: 'asw-flight-item',
  templateUrl: './flight-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlightItemComponent extends SupportComponent {
  id = this.constructor.name;
  @Input() boundIdx!: number;
  @Input() flightIdx!: number;
  @Input() isFirstFlight!: boolean;
  @Input() isLastFlight!: boolean;

  flight: Type1 = {};
  bound: Bound = {};
  totalFlight: number = 0;
  isEarlyDeparture: boolean = false;

  private _subscriptions = new Subscription();

  constructor(
    public tripSummarySvc: TripSummaryService,
    private _myBookingItineraryService: MyBookingItineraryService,
    private _servicingCommonStoreService: ServicingCommonStoreService,
    private _change: ChangeDetectorRef,
    _common: CommonLibService
  ) {
    super(_common);
  }

  override init(): void {
    this._subscriptions.add(
      this._servicingCommonStoreService.getServicingCommonModel$().subscribe((servicingCommon) => {
        const pnr = (servicingCommon.getOrder as GetOrderResponseData) ?? {};
        this.bound = pnr.air?.bounds?.at(this.boundIdx) ?? {};
        this.flight = this.bound.flights?.at(this.flightIdx) ?? {};
        this.totalFlight = this.bound.flights?.length ?? 0;
        this.isEarlyDeparture = this.bound.earlyDeparture?.isContainedSegment ?? false;
        this._change.markForCheck();
      })
    );
  }

  isMultiAirportConnection(index: number) {
    return this.bound.flights?.at(index)?.isMultiAirportConnection ?? false;
  }

  override reload(): void {
    // Add comment to passed SonarLint
  }

  override destroy(): void {
    if (this._subscriptions) {
      this._subscriptions.unsubscribe();
    }
  }
}
